<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header></top-header>
        <main-menu></main-menu>
        <!-- Start the code for this screen here -->
        <div class="container-fluid menu-margin-top">
          <iframe
            :src="page"
            width="100%"
            height="980px"
            id="receiver"
            style="position:relative;z-index:0"
            name="myIframe"
          ></iframe>
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
export default {
  components: { MainMenu, TopHeader, BottomFooter },
  data () {
    return {
      page: 'http://localhost:8080/contactus'
    }
  }
}
</script>
<style scoped>
</style>
